module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-320x480.c1d76bb4.jpg";